import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';

/**
 * Shared Back button rendered at the top of content screens.
 * Goes back one history entry when there is one; on a direct landing
 * (no in-app history) it navigates to `fallback` instead (default '/').
 */
const BackButton = ({ fallback = '/' }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate(fallback);
    }
  };

  return (
    <Button
      size="small"
      startIcon={<ArrowBackIcon />}
      onClick={handleBack}
      sx={{ textTransform: 'none', fontWeight: 600, mb: 1.5, alignSelf: 'flex-start' }}
    >
      Back
    </Button>
  );
};

export default BackButton;
